/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

export function Row({ children, ...props }) {
  return <tr {...props}>{children}</tr>;
}

export function Cell({ children, ...props }) {
  return <td {...props}>{children}</td>;
}

export function HCell({ children, ...props }) {
  return <th {...props}>{children}</th>;
}

export function TableHead({ children, ...props }) {
  return <thead {...props}>{children}</thead>;
}

export function TableBody({ children, ...props }) {
  return <tbody {...props}>{children}</tbody>;
}

export function TableFoot({ children, ...props }) {
  return <tfoot {...props}>{children}</tfoot>;
}

export function Table({ children, ...props }) {
  return (
    <div className="sdp-table-wrpper">
      <table className="sdp-table" {...props}>
        {children}
      </table>
    </div>
  );
}

Row.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.element]).isRequired
};

Cell.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.element]).isRequired
};

HCell.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.element]).isRequired
};

TableHead.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.element]).isRequired
};

TableBody.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.element]).isRequired
};

TableFoot.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.element]).isRequired
};

Table.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.element]).isRequired
};
